// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2fyNW","open":"open___3JJkh","notes":"notes___685AA"};